import { FDC as FDCModule } from '../../CIMSModule/instances'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const FDC = 'Field Design Change'
const FDCWF = `${FDC}s workflow`

export const FDCAdmin = new RoleTemplateItem({
  id: 'becf2bc8-a986-408d-b904-f6437f147d70',
  name: `${FDC} Admin`,
  description: `Gives users access to all permissions within the ${FDCWF}`,
  module: FDCModule,
  permissionItems: Permission.findByModule(FDCModule),
})

export const FDCCreator = new RoleTemplateItem({
  id: 'cb8f90be-5f72-4acb-b623-e4386d117252',
  name: `${FDC} Creator`,
  description: `Allows users to Create new ${FDC}s`,
  module: FDCModule,
  permissionItems: [
    Permission.ViewFieldDesignChange,
    Permission.CreateFieldDesignChange,
    Permission.EditFieldDesignChangeResolution,
    Permission.RemoveRestoreFieldDesignChange,
    Permission.CommentOnFieldDesignChange,
  ],
})

export type FDCRoleTemplateItem = typeof FDCAdmin | typeof FDCCreator
